import type { CrewJob } from '../types/crewJobs';

export type CrewJobDateTask = {
  id?: string;
  projectId?: string;
  title: string;
  startDate?: Date | null;
  endDate?: Date | null;
};

export function tasksForCrewJobProject(
  tasks: CrewJobDateTask[],
  projectId: string | null | undefined,
): CrewJobDateTask[] {
  if (!projectId) return [];
  return tasks
    .filter(t => t.id && t.projectId === projectId)
    .sort((a, b) => {
      const aTime = a.startDate ? a.startDate.getTime() : Number.MAX_SAFE_INTEGER;
      const bTime = b.startDate ? b.startDate.getTime() : Number.MAX_SAFE_INTEGER;
      return aTime - bTime || a.title.localeCompare(b.title);
    });
}

export function resolveCrewJobDates(
  job: Pick<CrewJob, 'startDate' | 'endDate' | 'startTaskId' | 'endTaskId'>,
  tasks: CrewJobDateTask[],
): { startDate: Date | null; endDate: Date | null } {
  const startTask = tasks.find(t => t.id && t.id === job.startTaskId);
  const endTask = tasks.find(t => t.id && t.id === job.endTaskId);
  return {
    startDate: startTask?.startDate || job.startDate || null,
    endDate: endTask?.endDate || job.endDate || null,
  };
}

export function formatCrewTaskOptionLabel(
  task: CrewJobDateTask,
  which: 'start' | 'end',
): string {
  const date = which === 'start' ? task.startDate : task.endDate;
  const stamp = date
    ? date.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })
    : 'no date';
  return `${task.title} · ${which === 'start' ? 'starts' : 'ends'} ${stamp}`;
}
